import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'login',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/Login2FAContainer',
      './modules/login2FA'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Login2FA = require('./containers/Login2FAContainer').default
      const reducer = require('./modules/login2FA').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'login2FA', reducer: reducer })

      /*  Return getComponent   */
      cb(null, Login2FA)

    /* Webpack named bundle   */
    }, 'login')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Login2FA/index.js